export const CUSTOMER_ADMIN_PERMISSIONS = ["P1", "P2", "P3", "P4", "P5"];

export const SUPER_ADMIN_PERMISSIONS = ["P11", "P12", "P13", "P14", "P15", "P16", "P17", "P18", "P19", "P20"];
